import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import "./modal.css";

const SelectionModal = ({
    open,
    title = "Just one more thing...",
    fields = [], // [{ label, name, options }]
    onSubmit,
    onClose,
    btnText = "Submit",
}) => {
    if (!open) return null;

    // Build validation schema dynamically
    const validationSchema = Yup.object(
        fields.reduce((schema, field) => {
            schema[field.name] = Yup.string().required(`${field.label} is required`);
            return schema;
        }, {})
    );

    // Build initial values dynamically
    const initialValues = fields.reduce((vals, field) => {
        vals[field.name] = "";
        return vals;
    }, {});

    const handleSubmit = (values, setSubmitting) => {
        try {
            onSubmit?.(values);
            onClose?.();
        } catch (err) {
            toast.error("Something went wrong!");
        } finally {
            setSubmitting(false);
        }
    }


    return (
        <div className="selection-popup">
            <div className="popup-overlay">
                <div className="popup-box">
                    <h3>{title}</h3>

                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={(values, { setSubmitting }) => {
                            handleSubmit(values, setSubmitting)
                        }}
                    >
                        {({ isSubmitting }) => (
                            <Form>
                                {fields?.map((field) => (
                                    <div key={field.name} className="form-group">
                                        <label htmlFor={field.name}>{field.label}</label>
                                        <Field
                                            as="select"
                                            id={field.name}
                                            name={field.name}
                                            className="popup-dropdown-text"
                                        >
                                            <option value="">Select {field.label}</option>
                                            {field?.options?.map((opt) => (
                                                <option key={opt.value} value={opt.value}>
                                                    {opt.name}
                                                </option>
                                            ))}
                                        </Field>
                                        <ErrorMessage
                                            name={field.name}
                                            component="div"
                                            className="text-danger"
                                        />
                                    </div>
                                ))}

                                <button
                                    className="submit-btn"
                                    type="submit"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? "Submitting..." : btnText}
                                </button>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </div>
    );
};

export default SelectionModal;
